import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';

const pushHistory = (route, history, languageRegionCode = 'en-US') => {
  const localizedRoute = wrapUrlSafe(route, languageRegionCode);
  history.push(localizedRoute);
};

// pathname matching with locale
const localizedRouteIncludes = (pathname, routes = [], languageRegionCode = 'en-US') => {
  let path;

  if (languageRegionCode === 'en-US') {
    path = pathname;
  } else {
    const prefix = wrapUrlSafe('/', languageRegionCode);
    path = pathname.replace(prefix, '/');
  }

  return routes.includes(path);
};

export { pushHistory, localizedRouteIncludes };
